export default __webpack_public_path__ + "static/media/promo-code-white.61b98eb1.svg";